module.exports = {
      id: "star-usage",
      viewBox: "0 0 12 14",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#star-usage",
      toString: function () {
        return this.url;
      }
    }